import React from "react";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";

export const ResumenReporte = ({ totalGlobal = {} }) => {
    return (
        <div className="formulario-fields-row reporte-inventario__resumen">
            <div className="formulario-field text-center">
                <label className="formulario-field__label">
                    Total de ingresos lab
                </label>
                <div className="formulario-field__value">
                    <RenderKilogramo
                        value={totalGlobal.lab_ingresos || 0}
                        decimalScale={3}
                    />
                </div>
            </div>

            <div className="formulario-field text-center">
                <label className="formulario-field__label">
                    Total de ingresos liq
                </label>
                <div className="formulario-field__value">
                    <RenderKilogramo
                        value={totalGlobal.liq_ingresos || 0}
                        decimalScale={3}
                    />
                </div>
            </div>

            <div className="formulario-field text-center">
                <label className="formulario-field__label">
                    Enviado a producción lab
                </label>
                <div className="formulario-field__value">
                    <RenderKilogramo
                        value={totalGlobal.lab_enviado || 0}
                        decimalScale={3}
                    />
                </div>
            </div>

            <div className="formulario-field text-center">
                <label className="formulario-field__label">
                    Enviado a producción liq
                </label>
                <div className="formulario-field__value">
                    <RenderKilogramo
                        value={totalGlobal.liq_enviado || 0}
                        decimalScale={3}
                    />
                </div>
            </div>
        </div>
    );
};
